const FREE_EXPANSION = "free_expansion";
const PREMIUM1_EXPANSION = "premium1_expansion";
const PREMIUM2_EXPANSION = "premium2_expansion";
const PREMIUM3_EXPANSION = "premium3_expansion";

export {
  FREE_EXPANSION,
  PREMIUM1_EXPANSION,
  PREMIUM2_EXPANSION,
  PREMIUM3_EXPANSION
};
